import { render, staticRenderFns } from "./TestBookingManageList.vue?vue&type=template&id=c33252b8&scoped=true"
import script from "./TestBookingManageList.vue?vue&type=script&lang=js"
export * from "./TestBookingManageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c33252b8",
  null
  
)

export default component.exports